import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Contact = () => {
    useEffect(() => {
        AOS.init({
            duration: 600,
        })
    }, [])
    return (
        <div id="contact" style={{ background: "#2B3436" }}>
            <div className="container">
                <h1
                    data-aos="fade-right"
                    className="text-center text-white pt-5 pb-3 section-border">Contact me</h1>

                <div
                    data-aos="fade-left"
                    className="w-50 mx-auto pb-5 pt-4">
                    <form action="https://formspree.io/f/xlezrlqb"
                        method="POST">
                        <div className="mb-3">
                            <label for="email" className="form-label text-white">Your Email</label>

                            <input type="email" className="form-control" id="email" name="_replyto" placeholder="Your Email" />
                        </div>
                        <div className="mb-3">
                            <label for="message" className="form-label text-white">Message</label>

                            <textarea className="form-control" name="message" id="message" rows="3" placeholder="Message"></textarea>
                        </div>
                        <button type="submit" style={{ background: "#1A5E9D" }} className="btn px-4 mb-5 mt-2 text-white"><i class="far fa-paper-plane"></i> Send</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;